import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable, map } from 'rxjs';
import type { AbancaPoliza } from '../../../models/AbancaPoliza';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AbancaService
{
  constructor(
    private http:HttpClient,
    private msal:MsalService,
  )
  {
  }

  buscarPoliza(token:string, matricula:string): Observable<AbancaPoliza[]> {
    const url = environment.callCenterWSBase + "/Abanca/";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
      .set('Authorization', 'Bearer ' + token),

      params: new HttpParams({})
    };

    const query = {
      select:
      [
        "id_poliza",
        "coalesce(nombre, '') as nombre",
        "coalesce(apellidos_razonsocial, '') as apellidos_razonsocial",
        "coalesce(direccion, '') as direccion",
        "coalesce(localidad, '') as localidad",
        "coalesce(cp, '') as cp",
        "coalesce(marca, '') as marca",
        "coalesce(modelo, '') as modelo",
        "coalesce(nif, '') as nif",
        "coalesce(email, '') as email",
        "coalesce(telefono_1, '') as telefono_1",
        "coalesce(telefono_2, '') as telefono_2",
        "coalesce(fecha_ini_contrato, '1970/01/01') as fecha_ini_contrato",
        "coalesce(fecha_ini_cobertura, '1970/01/01') as fecha_ini_cobertura",
        "coalesce(fecha_ven_contrato, '1970/01/01') as fecha_ven_contrato",
      ],
      parameters: [
        [{
          campo:"matricula",
          operacion:"=",
          valor:matricula.toUpperCase(),
        }],
      ],
    };

    return this.http.post<AbancaPoliza[]>(url, query, httpOptions)
      .pipe(
        map((data) => {
          return data.map(x => {
            x.fecha_ini_contrato = new Date(x.fecha_ini_contrato);
            x.fecha_ini_cobertura = new Date(x.fecha_ini_cobertura);
            x.fecha_ven_contrato = new Date(x.fecha_ven_contrato);
            return x;
          });
        })
      );
  }
}
